var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"open-mini-wrapper"},[_c('ElButton',{staticClass:"open-btn",attrs:{"type":"primary"},on:{"click":_vm.openMini}},[_vm._v(" 打开小程序 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }